/**
 * Markdown source renderer.
 * Renders syntax-colored markdown text into a container element.
 */

function mkSpan(cls, text) {
  const s = document.createElement('span');
  s.className = cls;
  s.textContent = text;
  return s;
}

/**
 * Render raw markdown text into a container element with syntax coloring.
 * @param {string} text - Raw markdown content
 * @param {HTMLElement} container - Element to render into (typically a <pre>)
 */
export function renderMarkdownSource(text, container) {
  container.textContent = '';

  let inFrontmatter = false;
  let frontmatterDone = false;

  const lines = text.split('\n');
  lines.forEach((line, i) => {
    const span = document.createElement('span');
    span.className = 'mv-line';

    // Frontmatter: --- delimited block at the top
    if (!frontmatterDone && line === '---') {
      if (!inFrontmatter) {
        inFrontmatter = true;
      } else {
        inFrontmatter = false;
        frontmatterDone = true;
      }
      span.appendChild(mkSpan('mv-syntax', '---'));
    } else if (inFrontmatter) {
      const colon = line.indexOf(':');
      if (colon !== -1) {
        span.append(
          mkSpan('mv-flag', line.slice(0, colon + 1)),
          mkSpan('mv-body', line.slice(colon + 1)),
        );
      } else {
        span.textContent = line;
      }
    } else if (line.startsWith('# ') && !line.startsWith('## ')) {
      span.classList.add('mv-heading');
      span.textContent = line;
    } else if (line.startsWith('## ')) {
      span.classList.add('mv-heading');
      span.textContent = line;
    } else if (/^\[component:/.test(line)) {
      const match = line.match(/^(\[component:)([^\s\]]+)(.*?)(\])$/);
      if (match) {
        const [, open, name, propsStr, close] = match;
        span.append(
          mkSpan('mv-syntax', open),
          mkSpan('mv-component', name),
          mkSpan('mv-body', propsStr),
          mkSpan('mv-syntax', close),
        );
      } else {
        span.textContent = line;
      }
      span.classList.add('mv-component');
    } else if (/^!\[/.test(line)) {
      const match = line.match(/^(!\[)([^\]]*?)(\]\()([^)]+)(\))((?:\{no-border\}|\{mobile-only\})*)$/);
      if (match) {
        const [, open, alt, mid, src, close, flag] = match;
        span.append(
          mkSpan('mv-syntax', open),
          mkSpan('mv-alt', alt),
          mkSpan('mv-syntax', mid),
          mkSpan('mv-src', src),
          mkSpan('mv-syntax', close),
          ...(flag ? [mkSpan('mv-flag', flag)] : []),
        );
      } else {
        span.textContent = line;
      }
      span.classList.add('mv-image');
    } else if (line.trim() === '') {
      span.classList.add('mv-blank');
      span.textContent = '\u200B';
    } else {
      span.classList.add('mv-body');
      span.textContent = line;
    }

    container.appendChild(span);
    if (i < lines.length - 1) container.appendChild(document.createTextNode('\n'));
  });
}
